import { ESSENTIAL_PRODUCTS, PRIVATE_WEALTH_PRODUCTS } from "./productRouteMap";

const LIVE_PRIVATE_WEALTH = PRIVATE_WEALTH_PRODUCTS.filter(
  (p) => !p.comingSoon && !p.hidden,
);

export const PRODUCT_UI_BY_CODE = [
  ...ESSENTIAL_PRODUCTS,
  ...LIVE_PRIVATE_WEALTH,
].reduce((acc, product) => {
  acc[product.code] = {
    id: product.id,
    code: product.code,
    icon: product.icon,
    lockedHero: product.lockedHero,
    gradient: product.gradient,
    accentColor: product.accentColor,
    theme: product.theme,
    onboardingPath: product.onboardingPath,
    productInfoPath: product.productInfoPath,
    dashboardPath: product.dashboardPath,
    holdingsPath: product.holdingsPath,
    actionCentrePath: product.actionCentrePath,
    needsFirstRender: product.needsFirstRender,
    clearPlanIdOnStart: product.clearPlanIdOnStart,
    comingSoon: Boolean(product.comingSoon),
    ctaLabel: product.ctaLabel,
    description: product.description,
    subtitle: product.subtitle,
    showComingSoonCentered: product.showComingSoonCentered,
    forceInPortfolioTab: Boolean(product.forceInPortfolioTab),
  };
  return acc;
}, {});
